import { APP_BASE_HREF } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { FilterDialogComponent } from '@app/pages/common/filter-dialog/filter-dialog.component';
import { ShowHideDialogComponent } from '@app/pages/common/show-hide-dialog/show-hide-dialog.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { TableLazyLoadEvent } from 'primeng/table';
import { catchError, EMPTY, map } from 'rxjs';

@Component({
  selector: 'app-livestatuses',
  templateUrl: './livestatuses.component.html',
  styleUrls: ['./livestatuses.component.scss'],
})
export class LivestatusesComponent implements OnInit, OnDestroy {
  intervalId: any;
  constructor(
    private utils: Utils,
    private webStorage: WebStorageService,
    private appService: AppService,
    private managerService: ManagerService,
    private router: Router,
    private modalService: BsModalService,
    private cd: ChangeDetectorRef,
    @Inject(APP_BASE_HREF) public baseHref: string
  ) {}
  currentMenu: any = {};
  action = '';
  innerHeight = 60;
  showTable: boolean = true;
  showCrud: boolean = false;
  showDateRange: boolean = false;
  first = 0;
  rows = 10;
  totalRecords: number;
  loading: boolean;
  modalRef?: BsModalRef;
  liveStatusList: any = [];
  liveStatusListFilter: any = [];
  localStorageName = 'LivestatusesColumnDisplaySettings';
  headercount: any = { shown: 0, hidden: 0 };
  showHideColumnsTimeout: any;
  /*globalfilter*/
  findOptions: any = [
    { label: 'First Name', value: 'FirstName' },
    { label: 'Last Name', value: 'LastName' },
    { label: 'User ID', value: 'UserID' },
    { label: 'Email', value: 'Email' },
  ];

  rowOffset = 0;
  rowCount = 50;
  searchField: any = { label: '', value: '' };
  searchValue: any = '';
  filterDict: any = null;
  sortColumn = 'Name';
  sortDescend = true;
  filterOptionRequestColumn = null;
  pl: any = {};
  filterdataLivestatus: any ={};
  cols: any = [
    { name: 'ID', label: 'ID', showFilter: false },
    { name: 'Name', label: 'Name', showFilter: false },
    // { name: 'Type', label: 'Type', showFilter: true },
    { name: 'Group', label: 'Group', showFilter: true },
    { name: 'Status', label: 'Status', showFilter: true },
    {
      name: 'Duration',
      label: 'Duration',
      type: 'numeric',
      format: 'duration',
    },
    { name: 'QueueType', label: 'Queue Type', showFilter: true },
    { name: 'QueueName', label: 'Queue', showFilter: true },
    { name: 'InteractionsToday', label: 'Interactions Today' },
    { name: 'LastInteraction', label: 'Last Interaction', type: 'date' },
  ];
  showColumnFilterModalTimeout: any;
  ngOnInit(): void {
    this.pl = {
      rowOffset: 0,
      rowCount: 10,
      filterOptionRequestColumn: this.filterOptionRequestColumn,
      searchValue: this.searchValue,
      searchField: this.searchField.value,
      filterDict: this.filterDict,
      sortColumn: this.sortColumn,
      sortDescend: this.sortDescend,
      currentUserOnly: false,
      isExport: false,
    };

    this.appService.currentMenu.subscribe((val: boolean) => {
      this.currentMenu = val;
     if(this.currentMenu?.name == 'LiveStatuses'){
      this.currentMenu.name = 'Live'+' '+'Statuses';
    }
     this.action = this.currentMenu?.name;
     
    });
    this.searchField = this.findOptions[0];
    this.initializeColumnHeader();
    this.loadLiveStatuses(null);
  }

  initializeColumnHeader() {
    const localCol = this.webStorage.getItemFromLocalStorage(this.localStorageName);
    if (localCol != null) {
      this.cols = localCol;
    } else {
      for (const col of this.cols) {
        if (col.name == this.sortColumn) {
          if (this.sortDescend) {
            col.isAsc = false;
          } else {
            col.isAsc = true;
          }
        } else {
          delete col.isAsc;
        }
        col.hide = false;
      }
      this.webStorage.setItemInLocalStorage(this.localStorageName, this.cols);
    }
    this.getColumnCount();
  }
  ngOnDestroy() {
    this.intervalId && clearInterval(this.intervalId);
    this.showHideColumnsTimeout && clearTimeout(this.showHideColumnsTimeout);
    this.showColumnFilterModalTimeout && clearTimeout(this.showColumnFilterModalTimeout);
  }
  getColumnCount() {
    let shown = 0;
    let hidden = 0;
    for (const header of this.cols) {
      if (header.hide) {
        hidden++;
      } else {
        shown++;
      }
    }
    this.headercount.shown = shown;
    this.headercount.hidden = hidden;
  }

  /*globalFilter*/
  clearSearchBox() {
    this.searchValue = '';
    this.pl['searchField'] = { label: '', value: '' };
    this.loadLiveStatuses(null);
  }

  applyFilterByField(val: any) {
    this.searchField = val.searchField;
    this.searchValue = val.searchValue;
    this.first = 0;
    this.loadLiveStatuses(null);
  }
  
  /*column filter* starts here*/
  toggleCustomColumnFilter(colName: string) {
    this.filterOptionRequestColumn = colName;
    this.loadLiveStatuses(null);
  }
  showColumnFilterModal(colName: string) {
    const initialState = {
      cols: this.cols,
      colName: colName,
    };
    const config: ModalOptions = { 
      class: 'task-menu', 
      initialState,
      backdrop: 'static',
      keyboard: false,
      animated: true
    };
    
    this.showColumnFilterModalTimeout = setTimeout(() => {
      this.modalRef = this.modalService.show(FilterDialogComponent, config);
      
      // Ensure backdrop is visible
      const backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) {
        backdrop.classList.add('show');
      }
      
      this.modalRef.content.event.subscribe((result: any) => {
        this.cols = result.data;
        this.applyColumnFilters();
      });
      
      this.cd.detectChanges();
    }, 0);
  }

  /*column level filter*/
  applyColumnFilters() {
    this.filterDict = [];
    this.filterOptionRequestColumn = null;
    for (const colData of this.cols) {
      const filterVals: string[] = [];
      if (colData.filterVals && colData.filterVals.length > 0) {
        for (const val of colData.filterVals) {
          if (val.checked) {
            // Handle null values - don't convert to string if null
            const valueToAdd = val.name != null ? val.name.toString() : null;
            filterVals.push(valueToAdd);
          }
        }
        if (filterVals.length > 0) {
          let key = colData.name; key = this.correctFilterColumnName(key);
          this.filterDict.push({ Key: key, Value: filterVals });
        }
      }
    }
    
    // Set to null if no filters applied
    if (this.filterDict.length === 0) {
      this.filterDict = null;
    }
    
    this.first = 0;
    this.loadLiveStatuses(null);
  }
  
  // Helper method to check if column has active filters
  hasActiveFilter(colName: string): boolean {
    const col = this.cols.find((c) => c.name === colName);
    if (!col || !col.filterVals) return false;
    
    return col.filterVals.some((fv: any) => fv.checked === true);
  }
  
  showHideColumns() {
    const initialState = {
      headerNames: this.cols,
      localStorageName: this.localStorageName,
    };
    const config: ModalOptions = { 
      class: 'task-menu', 
      initialState,
      backdrop: 'static',
      keyboard: false,
      animated: true
    };
    
     this.showHideColumnsTimeout = setTimeout(() => {
      this.modalRef = this.modalService.show(ShowHideDialogComponent, config);
      
      // Ensure backdrop is visible
      const backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) {
        backdrop.classList.add('show');
      }
      
      this.modalRef.content.event.subscribe((result: any) => {
        this.initializeColumnHeader();
      });
      
      this.cd.detectChanges();
    }, 0);
  }
  sortByColumn(colName: string) {
    this.sortColumn = colName;
    this.sortDescend = !this.sortDescend;
    this.cols = this.utils.sortByFieldInServer(colName, this.cols);
    this.webStorage.setItemInLocalStorage(this.localStorageName, this.cols);
    this.loadLiveStatuses(null);
  }

  onRowSelect(event: any) {
    this.router.navigateByUrl(this.router.url + '/Details/' + event.data.ID);
  }
  loadLiveStatuses(event: any) {
    console.log('loadLiveStatuses called with event:', event);

    // Handle pagination from event if provided
    if (event) {
      this.first = event.first || 0;
      this.rows = event.rows || 10;
    }

    // Clear any existing interval
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    // If requesting filter options, fetch immediately without interval
    if (this.filterOptionRequestColumn) {
      this.getLiveStatuses(event);
      return;
    }

    // Initial load
    this.getLiveStatuses(event);

    // Set up auto-refresh every 3 seconds for live updates
    this.intervalId = setInterval(() => {
      if (!this.filterOptionRequestColumn) {
        this.getLiveStatuses(event);
      }
    }, 20000);
  }
  
  getLiveStatuses(event: any) {
    this.loading = true;

    // Calculate pagination
    const rowOffset = this.first || 0;
    const rowCount = this.rows || 10;

    // Build request payload
    const pl: any = {
      rowOffset: rowOffset,
      rowCount: rowCount,
      currentUserOnly: false,
      isExport: false,
    };

    // Add search parameters
    if (this.searchField && this.searchValue) {
      pl.searchField = this.searchField.value || this.searchField;
      pl.searchValue = this.searchValue;
    } else {
      pl.searchField = '';
      pl.searchValue = '';
    }

    // Add column filters (always include, either as array or null)
    if (this.filterDict && Array.isArray(this.filterDict) && this.filterDict.length > 0) {
      pl.filterDict = this.filterDict;
    } else {
      pl.filterDict = null;
    }

    // Add sort parameters
    if (this.sortColumn) {
      pl.sortColumn = this.sortColumn;
      pl.sortDescend = this.sortDescend;
    }

    // Add filter option request if needed (null if not requesting)
    let filterOptionRequestColumn = this.correctFilterColumnName(this.filterOptionRequestColumn);
    if (filterOptionRequestColumn) {
      pl.filterOptionRequestColumn = filterOptionRequestColumn;
    } else {
      pl.filterOptionRequestColumn = null;
    }

    console.log('Request payload:', pl);

    // Call API
    this.managerService.GetLiveStatuses(pl).subscribe({
      next: (data: any) => {
        console.log('API Response:', data);

        const isValid = ResponseHandler.processResponse(data, 'GetLiveStatuses');
        if (!isValid) {
          this.loading = false;
          return;
        }

        // Handle filter options response
        if (this.filterOptionRequestColumn) {
          const requestedColumn = this.filterOptionRequestColumn; // Save before resetting
          const col = this.cols.find((c) => c.name === requestedColumn);
          
          if (col && data.Response && Array.isArray(data.Response.Data)) {
            // Get existing checked values to preserve selections
            const existingCheckedValues = col.filterVals
              ? col.filterVals.filter((fv: any) => fv.checked).map((fv: any) => fv.name)
              : [];

            // Build filter values array
            col.filterVals = data.Response.Data.map((dt: any) => {
              // Handle different data types
              let displayValue = dt;
              
              if (dt === null || dt === undefined) {
                displayValue = null;
              } else if (typeof dt === 'string' && dt.trim() === '') {
                displayValue = null;
              }

              return {
                name: displayValue,
                checked: existingCheckedValues.includes(displayValue),
              };
            });

            console.log(`Filter options for ${requestedColumn}:`, col.filterVals);

            // Reset filter option request BEFORE showing modal
            this.filterOptionRequestColumn = null;
            this.loading = false;

            // Show the filter dialog
            this.showColumnFilterModal(requestedColumn);
          } else {
            console.error('Failed to get filter options:', { col, response: data.Response });
            this.filterOptionRequestColumn = null;
            this.loading = false;
          }
        } else {
          // Handle normal data response
          if (data.Response && data.Response.Data) {
            if (Array.isArray(data.Response.Data.Data)) {
              this.liveStatusList = data.Response.Data.Data;
              
              // Format duration
              this.liveStatusList.forEach(element => {
                if (element.Duration) {
                  element.Duration = this.utils.formatDuration(element.Duration, 'sec', false, true, false);
                }
              });
              
              this.totalRecords = data.Response.Data.TotalFilteredItems || this.liveStatusList.length;
            } else if (Array.isArray(data.Response.Data)) {
              this.liveStatusList = data.Response.Data;
              this.totalRecords = this.liveStatusList.length;
            } else {
              console.error('Unexpected data structure:', data.Response.Data);
              this.liveStatusList = [];
              this.totalRecords = 0;
            }
          } else {
            this.liveStatusList = [];
            this.totalRecords = 0;
          }

          this.loading = false;

          // Force update if event has forceUpdate method
          if (event?.forceUpdate) {
            event.forceUpdate();
          }
        }

        this.cd.detectChanges();
      },
      error: (err) => {
        console.error('Error loading live statuses:', err);
        this.loading = false;
        this.liveStatusList = [];
        this.totalRecords = 0;
        this.filterOptionRequestColumn = null;
        this.cd.detectChanges();
      },
    });
  }
  resetTable() {
    this.first = 0;
    this.liveStatusList = [];
    this.totalRecords = 0;

    this.pl['rowOffset'] = this.rowOffset;
    this.pl['rowCount'] = this.rowCount;
    this.pl['filterDict'] = this.filterDict;
    this.pl['filterOptionRequestColumn'] = this.filterOptionRequestColumn;
    this.pl['sortDescend'] = this.sortDescend;
    this.pl['sortColumn'] = this.sortColumn;
    this.pl['searchValue'] = this.searchValue;
    if (this.pl['searchValue'] != '') {
      this.pl['searchField'] = this.searchField.value;
    } else {
      this.pl['searchField'] = '';
    }
  }

  setInnerWidthHeightParameters() {
    this.innerHeight = window.innerHeight * 0.7;
  }
  clearFilter() {
    // Clear all filter values and uncheck all selections
    this.cols?.forEach((col: any) => {
      if (col.filterVals) {
        col.filterVals.forEach((fv: any) => {
          fv.checked = false;
        });
      }
    });
    
    // Clear the filter dictionary
    this.filterDict = null;
    
    // Reset to first page
    this.first = 0;
    
    // Reload data without filters
    this.loadLiveStatuses(null);
  }

  correctFilterColumnName(colName: string): any {
    let key = colName;
    if(colName == 'QueueType'){
      key = 'Queue Type';
    }else if(colName == 'QueueName'){
      key = 'Queue';
    }
    return key;
  }

}
